import { Info } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

export const BannerNote = ({
  note,
  title = "Data Source Information",
  marqueeSpeed = 15,
  infinite = false,
  delay = 0,
  maxNonInfiniteRounds = 2,
  rootClassName = "",
  bannerClassName = ""
}: {
  note: string;
  title?: string;
  marqueeSpeed?: number;
  infinite?: boolean;
  delay?: number;
  maxNonInfiniteRounds?: number;
  rootClassName?: string
  bannerClassName?: string
}) => {
  const { t } = useTranslation();
  return (
    <div className={`mt-3 ${rootClassName}`}>
      <div className={`flex items-center gap-3 bg-blue-50 border border-blue-200 rounded-lg px-4 py-2 ${bannerClassName}`}>
        <div className="flex-shrink-0">
          <Info className="w-5 h-5 text-blue-600" weight="fill" />
        </div>
        <div className="flex-shrink-0">
          <h4 className="text-sm font-medium text-blue-900">{t(title || "common.dataSourceInfo", title)}:</h4>
        </div>
        <div className="flex-1 overflow-hidden relative">
          <div
            className="whitespace-nowrap text-[12px] text-blue-800 animate-marquee"
            style={{
              animation: `marquee ${marqueeSpeed}s linear ${delay}s ${infinite ? "infinite" : maxNonInfiniteRounds
                }`,
            }}
          >
            {note}
          </div>
        </div>
      </div>
    </div>
  );
};

export const BannerHeightOffset = 45;
